const storeName = 'myAccount';
const getCardData = state => state[storeName];

const getData = state => getCardData(state).data || {};
const getlostOrStolenFormData = state => getData(state).lostOrStolenFormData || {};
const getCardNumber = (state, storeName) => state[storeName].data.cardNumber;
const getPinCode = (state, storeName) => state[storeName].data.pinCode;
const getSaveCard = state => getCardData(state).saveCards || {};
const getCards = state => getSaveCard(state).payments || [];
const getSelectedCard = state => getCardData(state).selectedCard;
const getSTBDefaultMsg = state => getCardData(state).swipeToBuyDefaultError;
const getCardLoaded = state => getCardData(state).cardLoaded;
const getCardNumberMask = state => {
    return getlostOrStolenFormData(state)[0] ? getlostOrStolenFormData(state)[0].mask : '';
};
const swipeToBuyValidationErrorType = state => getData(state).swipeToBuyValidationErrorType;
const swipeToBuyValidationError = state => getData(state).swipeToBuyValidationErrorType !== '';
const setSwipeOrderConfirmationCode = state => getData(state).swipeOrderConfirmationCode;
const showSwipeToBuyError = state => getData(state).showSwipeToBuyError || false;
const getSwipeToBuyErrorType = state => getData(state).swipeToBuyErrorType || '';

export default {
    getData,
    getCardNumber,
    getCardNumberMask,
    getPinCode,
    getCards,
    getSelectedCard,
    getSTBDefaultMsg,
    getCardLoaded,
    swipeToBuyValidationErrorType,
    swipeToBuyValidationError,
    setSwipeOrderConfirmationCode,
    showSwipeToBuyError,
    getSwipeToBuyErrorType,
};
